import styled from 'styled-components';
import { Spin } from 'antd';
import { DefaultTheme } from 'styled-components';

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(props: { theme?: DefaultTheme }, darkValue: T, lightValue: T): T => {
  return props.theme?.mode === 'dark' ? darkValue : lightValue;
};

export const SpinnerContainer = styled.div<{ $fullScreen?: boolean; $padding?: number | string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: ${(props) => {
    if (props.$fullScreen) return '0';
    if (typeof props.$padding === 'number') return `${props.$padding * 8}px`;
    return props.$padding || '32px';
  }};
  width: 100%;
  ${(props) =>
    props.$fullScreen &&
    `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${getThemeValue(props, 'rgba(26, 32, 44, 0.8)', 'rgba(255, 255, 255, 0.8)')};
    z-index: 9999;
  `}
`;

export const StyledSpin = styled(Spin)`
  .ant-spin-dot {
    i {
      background-color: ${(props) => getThemeValue(props, '#1890ff', '#1890ff')} !important;
    }
  }
`;

export const LoadingText = styled.span<{ $isDarkMode?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => getThemeValue(props, '#a0aec0', '#718096')} !important;
  text-align: center;
`;

export const FullScreenOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${(props) => getThemeValue(props, 'rgba(26, 32, 44, 0.8)', 'rgba(255, 255, 255, 0.8)')};
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;
